'use client';

import { useEffect } from 'react';
import Router from 'next/router';

export const useRouteChanges = (onRouteChangeCallback?: Function) => {
  useEffect(() => {
    const handleRouteChangeComplete = (url: string) => {
      console.log(`Route change to ${url} completed`);
      onRouteChangeCallback?.(url);
    };

    Router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      Router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [onRouteChangeCallback]);
};
